import { submitForm } from "../../services/api";
import { formatPaymentResponse } from "./utils";

export const sdkSubmitNativeForm = async ({
  intentId,
  paymentMethod,
  billingData = {},
  shippingData = {},
  cardEmbed = {},
  lang,
  saveCard,
  installmentPlanData,
}: {
  intentId: string;
  providerId: string;
  paymentMethod: string;
  billingData: Record<string, string>;
  shippingData: Record<string, string>;
  cardEmbed: Record<string, unknown>;
  lang: string;
  saveCard?: boolean;
  installmentPlanData?: {
    planId: string;
    issuerCode?: string;
  };
}) => {
  const { cardValidation, ...restCardEmbed } = cardEmbed;

  try {
    const paymentResponse = (await submitForm({
      intentID: intentId,
      paymentMethod,
      lang,
      data: {
        native_form: {
          card_fields: {},
          billing_fields: billingData,
          shipping_fields: shippingData,
          card_embed: {
            ...restCardEmbed,
            save_card: saveCard ?? restCardEmbed?.save_card,
          },
          product_items_fields: [],
        },
        card_validation: cardValidation,
        ...(installmentPlanData?.planId
          ? { installment_id: installmentPlanData.planId }
          : {}),
        ...(installmentPlanData?.issuerCode
          ? { issuer_code: installmentPlanData.issuerCode }
          : {}),
      },
    })) as unknown as PaymentApiResponse;

    return formatPaymentResponse(paymentResponse);
  } catch (error) {
    const errorsList = (await error?.json)?.status?.errors || [];
    return Promise.reject({
      isHttpError: error.isHttpError,
      json: errorsList.reduce((acc, curr) => ({ ...acc, ...curr }), {}),
    });
  }
};
